export const CHANGE_COLOR_BY_FEATURE = 'CHANGE_COLOR_BY_FEATURE';

export const changeColorByFeatureAction = (datasetKey, colorByFeature, featureValue) => ({
    type: CHANGE_COLOR_BY_FEATURE,
    datasetKey,
    colorByFeature,
    featureValue,
});
